import React from 'react'
import '../componentGlobalStyle.css'

export default function CommonParent(Props) {
    return Props.children
}
